export enum navigateAppTypes {
  UPDATE_NAVIGATE_APP = 'UPDATE_NAVIGATE_APP',
  REMOVE_NAVIGATE_APP = 'REMOVE_NAVIGATE_APP',
}
